<template>
  <div class="page page-family">
    <div
      class="page__wrap"
      data-animate="page-wrap"
      v-if="data.entry"
      :class="{
        'p-bot-3': count > limit,
      }"
    >
      <header class="row-1 p-top-3">
        <!-- Title -->
        <div class="row-1">
          <h1 data-animate="header-title" class="title-m">
            {{ data.entry?.title }}
          </h1>
        </div>
      </header>
      <ListingList
        class="row-1 m-top-3"
        :class="{
          'p-bot-3': count <= limit,
        }"
        :items="formattedProducts"
      />
      <WidgetPaginationListing
        v-if="count > limit"
        class="row-1 flex --justify-center m-top-5"
        :itemPerPage="limit"
        :total="count"
      />
    </div>
  </div>
</template>

<script setup>
import { isInSeries } from '~/assets/js/junk.js'

import { useCraftStore } from '@/store/craft.js'

import queries from '@/graphql/craft/queries/index.js'

import {
  onBeforeEnter,
  onEnter,
  onLeave,
} from '~/assets/js/page-transitions/listing.js'

definePageMeta({
  layout: 'default',
  pageTransition: {
    onBeforeEnter: (el) => {
      onBeforeEnter(el)
    },
    onEnter: async (el, done) => {
      const tl = onEnter(el)
      await tl.delay(0.5).play()
      done()
    },
    onLeave: async (el, done) => {
      const tl = onLeave(el)
      await tl.play()
      window.lenis.scrollTo(0, { immediate: true })
      done()
    },
  },
})

// Fetch Craft
const { configuration } = useCraftStore()
const route = useRoute()

const limit = ref(25)

const query = queries.categories.getCategory
const type = 'product'

const categoryId = configuration.categoryId(useRoute().params.slug)
if (!categoryId) {
  throw createError({ statusCode: 404 })
}

const variables = computed(() => ({
  site: configuration.site,
  marketId: configuration.marketId,
  categoryId,
  type,
  limit: limit.value,
  offset: route.query?.page
    ? (parseInt(route.query?.page) - 1) * limit.value
    : 0,
}))

const { data } = await useGraphql(query, variables)

if (!data.value?.entry) {
  throw createError({ statusCode: 404 })
}

// Se il genitore non esiste vuol dire che questo prodotto non deve essere visualizzato in questo mercato e che c'è un errore in data entry
// TODO: Se i prodotti escludi dal mercato sono tanti questo filtro può causare qualche problema con i pagination e la visualizzazione delle pagine
const products = computed(
  () => data.value?.productsEntries?.filter((product) => product.parent) || []
)

/* watch(
  () => products.value,
  (products) => {
    if (!products.length) {
      throw createError({ statusCode: 404 })
    }
  },
  {
    immediate: true,
  }
) */

const count = computed(() => data.value?.entryCount || 0)

const formattedProducts = computed(() => {
  return products.value.map((product, index, array) => {
    //largeItem mi indica se nel listing il prodotto occupa più spazi
    const largeItem = isInSeries(index, array.length)
    return {
      title: product.title,
      cover: product.coverPortrait?.[0] || product.cover?.[0],
      route: {
        name: 'product-slug',
        params: { slug: product.slug },
      },
      largeItem,
    }
  })
})

const seo = computed(() => data.value?.entry?.seo || {})
const localeParams = computed(() => data.value?.entry?.localized || {})
// Seo
useSeo({
  ...seo.value,
  meta: [
    {
      name: 'description',
      content: seo.value?.description,
    },
  ],
  localeParams: useHelpers().generateSeoLocaleParams(localeParams, 'slug'),
})
</script>
